import type { Accordion } from 'melt/builders';
import { getContext, setContext } from 'svelte';

export const ACCORDION_CONTEXT_KEY = Symbol('accordion');
export const setAccordionContext = (accordion: Accordion<boolean> | undefined) =>
  setContext(ACCORDION_CONTEXT_KEY, accordion);
export const getAccordionContext = (): Accordion<boolean> | undefined =>
  getContext(ACCORDION_CONTEXT_KEY);
